import React from 'react';
import { connect } from 'react-redux';
import { Button, Spinner } from 'reactstrap';
import { getSiteTheme } from '../../actions/sites';

class SiteRow extends React.PureComponent {
  handleEditInfo = () => {
    const { dispatch, site } = this.props;
    getSiteTheme(site.site).then(() => {
      dispatch({ type: 'OPEN_EDIT_SITE' });
      dispatch({ type: 'SELECT_FORMULARY_SITE', payload: site.site });
    });
  };

  render() {
    const { site, loading } = this.props;

    return (
      <tr>
        <td className="text-center p-0 ps-1" />
        <td>
          {site.site}
          {
            loading
              ? (
                <span className="ms-2">
                  <Spinner style={{ width: '1rem', height: '1rem' }} type="grow" color="info" className="me-1" />
                  <Spinner style={{ width: '1rem', height: '1rem' }} type="grow" color="info" className="me-1" />
                  <Spinner style={{ width: '1rem', height: '1rem' }} type="grow" color="info" />
                </span>
              )
              : null
          }
        </td>
        <td className="px-3">
          <Button
            size="sm"
            block
            className="px-0 text-sky font-weight-bold"
            color="link"
            onClick={this.handleEditInfo}
          >
            Edit
          </Button>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (store) => ({
  loading: store.sites.loading,
});

export default connect(mapStateToProps)(SiteRow);
